let authKey;
let authValue;

export function setAuth(key, value) {
  authKey = key;
  authValue = value;
}

export function getAuth() {
  return {
    key: authKey,
    value: authValue,
  };
}
